import { AioReplacement } from "./interface";
import { newReplacementValues } from "./newReplacementValues";

/**
 * Create a new replacement with a blank template.
 *
 * @param blankT - The blank text template
 * @returns AioReplacement<T>
 */
export const newReplacement = <T>(blankT: T): AioReplacement<T> => {
  return {
    airid: crypto.randomUUID(),
    oldText: "",
    newTexts: [newReplacementValues(blankT)],
    includeTrailing: false,
  };
};
